// Get all floors
export const GET_LEASE_BUILDING_REQUEST = "GET_LEASE_BUILDING_REQUEST";
export const GET_LEASE_BUILDING_SUCCESS = "GET_LEASE_BUILDING_SUCCESS";
export const GET_LEASE_BUILDING_FAILURE = "GET_LEASE_BUILDING_FAILURE";

export const ADD_LEASE_BUILDING_REQUEST = "ADD_LEASE_BUILDING_REQUEST";
export const ADD_LEASE_BUILDING_SUCCESS = "ADD_LEASE_BUILDING_SUCCESS";
export const ADD_LEASE_BUILDING_FAILURE = "ADD_LEASE_BUILDING_FAILURE";

export const UPDATE_LEASE_BUILDING_REQUEST = "UPDATE_LEASE_BUILDING_REQUEST";
export const UPDATE_LEASE_BUILDING_SUCCESS = "UPDATE_LEASE_BUILDING_SUCCESS";
export const UPDATE_LEASE_BUILDING_FAILURE = "UPDATE_LEASE_BUILDING_FAILURE";

export const DELETE_LEASE_BUILDING_REQUEST = "DELETE_LEASE_BUILDING_REQUEST";
export const DELETE_LEASE_BUILDING_SUCCESS = "DELETE_LEASE_BUILDING_SUCCESS";
export const DELETE_LEASE_BUILDING_FAILURE = "DELETE_LEASE_BUILDING_FAILURE";

export const GET_LEASE_BUILDING_BY_ID_REQUEST = "GET_LEASE_BUILDING_BY_ID_REQUEST";
export const GET_LEASE_BUILDING_BY_ID_SUCCESS = "GET_LEASE_BUILDING_BY_ID_SUCCESS";
export const GET_LEASE_BUILDING_BY_ID_FAILURE = "GET_LEASE_BUILDING_BY_ID_FAILURE";

export const GET_LEASE_BUILDING_DYNAMIC_FIELDS_REQUEST = "GET_LEASE_BUILDING_DYNAMIC_FIELDS_REQUEST";
export const GET_LEASE_BUILDING_DYNAMIC_FIELDS_SUCCESS = "GET_LEASE_BUILDING_DYNAMIC_FIELDS_SUCCESS";
export const GET_LEASE_BUILDING_DYNAMIC_FIELDS_FAILURE = "GET_LEASE_BUILDING_DYNAMIC_FIELDS_FAILURE";

export const UPDATE_LEASE_ENTITY_PARAMS_SUCCESS = "UPDATE_LEASE_ENTITY_PARAMS_SUCCESS";
export const UPDATE_LEASE_ENTITY_PARAMS_FAILURE = "UPDATE_LEASE_ENTITY_PARAMS_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE";

export const RESET_REDUCER="RESET_REDUCER"